<template>
  <div>
    <v-card>
      <div class="text-xs-right">
        <v-btn fab small flat @click="$emit('close')">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <div class="px-3 pb-4">
        <Typography
          class="mb-2"
          h2
          bold
          :label="edittype === 'create' ? 'เพิ่มแคมเปญ' : 'แก้ไขแคมเปญ'"
        />
        <div class="form-control" :class="{ 'has-error': errors.has('ชื่อแคมเปญ') }">
          <div style="display: flex; justify-content: space-between">
            <Typography h5 semiBold label="ชื่อแคมเปญ*" />
            <!-- <toggle-button
              :value="input.status"
              :sync="true"
              @change="input.status = !input.status"
              :color="$vuetify.theme.success"
              :labels="{ checked: 'ON', unchecked: 'OFF' }"
              style="display: inline-block"
            /> -->
          </div>

          <input
            v-model="input.campaignname"
            type="text"
            name="ชื่อแคมเปญ"
            v-validate="'required'"
          />
          <p class="text-error" v-if="errors.has('ชื่อแคมเปญ')">{{ errors.first('ชื่อแคมเปญ') }}</p>
        </div>

        <div class="form-inline form-control" :class="{ 'has-error': errors.has('โครงการ') }">
          <Typography h5 semiBold label="โครงการ*" />
          <multiselect
            name="โครงการ"
            label="projectname"
            trackBy="projectname"
            :options="projectdata"
            v-model="input.projectid"
            :placeholder="$t('Project')"
            v-validate="'required'"
            :multiple="false"
          >
            <span slot="caret" :slot-scope="{ toggle }" class="arrow">
              <v-icon class="darkBlue" aria-hidden="false" size="24px">
                mdi-chevron-down
              </v-icon>
            </span>
          </multiselect>
          <p class="text-error" v-if="errors.has('โครงการ')">{{ errors.first('โครงการ') }}</p>
        </div>
        <v-flex xs12 class="mt-2">
          <div
            class="form-control"
            :class="{ 'has-error': errors.has('จำนวนสิทธิ์ที่สามารถขอได้') }"
          >
            <Typography h5 semiBold label="จำนวนสิทธิ์ที่สามารถขอได้*" />
            <div class="input-group">
              <input
                :name="'จำนวนสิทธิ์ที่สามารถขอได้'"
                v-model="input.couponpercentage"
                type="number"
                v-validate="'required'"
                class="form-control"
                :max="100"
              />
            </div>
            <p class="text-error" v-if="errors.has('จำนวนสิทธิ์ที่สามารถขอได้')">
              {{ errors.first('จำนวนสิทธิ์ที่สามารถขอได้') }}
            </p>
          </div>
          <div class="form-control">
            <v-checkbox hide-details v-model="input.multiplecoupon"  color="primary" label="Multiple Coupons"></v-checkbox>
          </div>
          <div style="border: 0.5px solid #EEEEEE; margin: 36px 0px"></div>
        </v-flex>
        <!-- <div class="form-control" :class="{ 'has-error': errors.has('ชื่อแคมเปญ') }">
          <label>ป้ายคาดเข้าร่วมแคมเปญ</label>
          <input
            v-model="input.joinword"
            type="text"
            name="ป้ายคาดเข้าร่วมแคมเปญ"
            v-validate="'max:15'"
          />
          <p class="text-error" v-if="errors.has('ป้ายคาดเข้าร่วมแคมเปญ')">
            {{ errors.first('ป้ายคาดเข้าร่วมแคมเปญ') }}
          </p>
        </div> -->
        <!-- <Typography class="mt-2" h5 semiBold label="จำนวนสิทธิ์ที่สามารถขอได้*" /> -->
        <div
          v-for="(item, k) in input.agency"
          :key="k"
          style="border: 1px solid grey; border-radius: 5px; position: relative"
          class="px-3 py-2 mb-2"
        >
          <div v-if="input.agency.length > 1" style="text-align: end">
            <img
              src="/static/img/TooltipDelete.png"
              alt
              class="responsive-img mb-1"
              @click="deleteItem(k)"
              style="height: 22px"
            />
            <!-- <v-btn small @click="deleteItem(k)" icon color="primary">
              <v-icon small>delete</v-icon>
            </v-btn> -->
          </div>
          <v-layout row wrap class="ma-0 pa-0" style="height: 82px">
            <v-flex xs6>
              <div
                class="form-inline form-control"
                :class="{ 'has-error': errors.has('ชื่อหน่วยร่วม') }"
              >
                <!-- <label>ชื่อหน่วยร่วม</label> -->
                <Typography h5 semiBold label="ชื่อหน่วยร่วม*" />
                <multiselect
                  @input="onChangeAgentname($event, k)"
                  :name="'ชื่อหน่วยร่วม'"
                  data-vv-as="ชื่อหน่วยร่วม"
                  v-model="item.agencyname"
                  label="name"
                  :show-labels="false"
                  v-validate="'required'"
                  placeholder="เลือกหน่วยร่วม"
                  :options="showAgencyOptions"
                  :searchable="false"
                ></multiselect>
                <p class="text-error" v-if="errors.has('ชื่อหน่วยร่วม')">
                  {{ errors.first('ชื่อหน่วยร่วม') }}
                </p>
              </div>
            </v-flex>
            <v-flex xs6 class="px-1">
              <div class="form-control" :class="{ 'has-error': errors.has('จำนวนคูปอง') }">
                <Typography h5 semiBold label="จำนวนคูปอง*" />
                <input
                  data-vv-as="จำนวนคูปอง"
                  :name="'จำนวนคูปอง'"
                  v-model="item.couponquantity"
                  type="number"
                  v-validate="'required'"
                  :max="9999"
                />
                <p class="text-error" v-if="errors.has('จำนวนคูปอง')">
                  {{ errors.first('จำนวนคูปอง') }}
                </p>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="ma-0 pa-0" style="height: 82px">
            <Typography h5 semiBold label="ระยะเวลาร่วมแคมเปญ*" />
            <v-flex xs12>
              <v-layout row wrap class="pa-0 ma-0">
                <v-flex xs6 class="form-control" :class="{ 'has-error': errors.has('Start date') }">
                  <div class="form-control" style="margin-right: 6px">
                    <date-picker
                      :append-to-body="false"
                      :clearable="true"
                      :editable="false"
                      input-class="dateSearch"
                      v-model="item.startdate"
                      valueType="date"
                      format="DD/MM/YYYY"
                      :placeholder="$t('เลือกวันที่เริ่ม')"
                      confirm
                      v-validate="'required'"
                      :name="'Start date'"
                    >
                      <template v-slot:footer="{ emit }">
                        <div style="text-align: left">
                          <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                            Today
                          </button>
                        </div>
                      </template>
                    </date-picker>
                  </div>

                  <p class="text-error" v-if="errors.has('Start date')">
                    {{ errors.first('Start date') }}
                  </p>
                  <!-- <DatepickerCustomDialog
                    v-validate="'required'"
                    v-model="item.startdate"
                    data-vv-as="Start date"
                    :name="'Start date' + k"
                  >
                    <input type="text" disabled :value="dateFormat(item.startdate)" />
                    <p class="text-error" v-if="errors.has('Start date' + k)">
                      {{ errors.first('Start date' + k) }}
                    </p>
                  </DatepickerCustomDialog> -->
                </v-flex>
                <v-flex
                  xs6
                  class="form-control pl-1"
                  :class="{ 'has-error': errors.has('End date') }"
                >
                  <div class="form-control" style="margin-right: 6px">
                    <date-picker
                      :append-to-body="false"
                      :clearable="true"
                      :editable="false"
                      input-class="dateSearch"
                      v-model="item.enddate"
                      valueType="date"
                      format="DD/MM/YYYY"
                      :placeholder="$t('เลือกวันที่สิ้นสุด')"
                      confirm
                      v-validate="'required'"
                      :name="'End date'"
                    >
                      <template v-slot:footer="{ emit }">
                        <div style="text-align: left">
                          <button class="mx-btn mx-btn-text" @click="emit(new Date())">
                            Today
                          </button>
                        </div>
                      </template>
                    </date-picker>
                  </div>
                  <p class="text-error" v-if="errors.has('End date')">
                    {{ errors.first('End date') }}
                  </p>
                  <!-- <DatepickerCustomDialog
                    v-validate="'required'"
                    v-model="item.enddate"
                    data-vv-as="End date"
                    :name="'End date' + k"
                  >
                    <input type="text" disabled :value="dateFormat(item.enddate)" />
                    <p class="text-error" v-if="errors.has('End date' + k)">
                      {{ errors.first('End date' + k) }}
                    </p>
                  </DatepickerCustomDialog> -->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <div>
            <div class="form-control" :class="{ 'has-error': errors.has('จังหวัด') }">
              <Typography h5 semiBold label="จังหวัด" />
              <div>
                <multiselect
                  :name="'จังหวัด'"
                  data-vv-as="จังหวัด"
                  v-validate="'required'"
                  :options="ProvinceOptions"
                  v-model="item.provincelist"
                  :placeholder="$t('Province')"
                  :multiple="true"
                  class="multi-tag-small"
                >
                </multiselect>
                <p class="text-error" v-if="errors.has('จังหวัด')">
                  {{ errors.first('จังหวัด') }}
                </p>
              </div>
              <div>
                <div class="text-xs-right">
                  <v-btn
                    style="text-decoration: underline; width: 50px; color: #26588b"
                    @click="ClearAllProvince(k)"
                    flat
                    small
                  >
                    <Typography h6 semiBold label="ล้างทั้งหมด"
                  /></v-btn>
                  <v-btn @click="selectAllProvince(k)" depressed :color="'#BECCDB'" small>
                    <Typography h6 semiBold label="เลือกทั้งหมด" />
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="text-xs-left cursor-5"
          @click="addMoreAgent"
          style="display: flex; align-items: center"
        >
          <img src="/static/img/addBlue.png" alt class="responsive-img" style="height: 16px" />
          <Typography class="ml-1" h6 semiBold label="เพิ่มหน่วยร่วม" />
          <!-- <v-btn class="ml-0" @click="addMoreAgent" outline small color="primary"
            ><i class="fas fa-plus mr-2"></i>เพิ่มหน่วยร่วม</v-btn
          > -->
        </div>
        <!-- <div class="text-xs-center">
          <v-btn @click="$emit('close')" color="grey" outline> Cancel</v-btn>
          <v-btn :loading="saveloading" @click="saveData" color="primary" depressed> Save</v-btn>
        </div> -->
        <div style="display: flex; justify-content: center">
          <Button :loading="saveloading" outline :label="$t('cancel')" @click="$emit('close')" />
          <Button :loading="saveloading" depressed :label="$t('Save')" @click="saveData" />
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import multiselect from 'vue-multiselect'
import Province from './Province.js'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import Typography from '@/components/elements/Typography.vue'
import DatePicker from 'vue2-datepicker'
import { ToggleButton } from 'vue-js-toggle-button'
import Button from '@/components/elements/Button.vue'
export default {
  components: {
    multiselect,
    DatepickerCustomDialog,
    Typography,
    DatePicker,
    Button,
    ToggleButton
  },
  props: ['agencyOptions', 'edittype', 'editdata', 'projectdata'],
  data() {
    return {
      saveloading: false,
      ProvinceOptions: Province,
      input: {
        status: false,
        projectid: '',
        campaignname: '',
        couponpercentage: null,
        multiplecoupon: false,
        agency: [
          {
            agencyname: '',
            couponquantity: null,
            provincelist: [],
            startdate: '',
            enddate: ''
          }
        ]
      }
    }
  },
  computed: {
    showAgencyOptions() {
      let list = []
      let temp_obj = {}
      let output = []
      if (this.input.agency && this.input.agency.length) {
        this.input.agency.forEach(data => {
          list.push(data.agencyname.name)
        })
      }
      this.agencyOptions.forEach(data => {
        if (data.name != name) {
          temp_obj[data.name] = data.provincelist
        }
      })
      // list.forEach( name => {
      //   this.agencyOptions.forEach(data => {
      //     if (data.name != name) {
      //       temp_obj[data.name] = data.provincelist
      //     }
      //   });
      // });
      for (const key in temp_obj) {
        let check = 1
        for (let i = 0; i < list.length; i++) {
          if (key == list[i]) {
            check = 0
          }
        }
        if (check) {
          output.push({
            name: key,
            provincelist: temp_obj[key]
          })
        }
      }
      return output
    }
  },
  mounted() {
    if (this.edittype == 'edit') {
      this.input.campaignname = this.editdata.campaignname
      this.input.couponpercentage = this.editdata.couponpercentage
      this.input.joinword = this.editdata.joinword
      this.input.multiplecoupon = this.editdata.multiplecoupon
      this.input.agency = this.editdata.agencylist.map(el => {
        var agencyname = this.agencyOptions.find(val => val.name === el.agencyname)
        // moment(el.enddate).format('YYYY-MM-DD')
        return {
          ...el,
          provincelist: el.provincelist,
          agencyname,
          enddate: moment(el.enddate).toDate(),
          startdate: moment(el.startdate).toDate()
        }
      })
      this.input.projectid = this.projectdata.find(val => val.id == this.editdata.projectid)
    }
  },
  methods: {
    selectAllProvince(key) {
      this.input.agency[key].provincelist = this.ProvinceOptions
    },
    ClearAllProvince(key) {
      this.input.agency[key].provincelist = []
    },
    onChangeAgentname(payload, k) {
      this.input.agency[k].provincelist = payload.provincelist.split(',')
    },
    deleteItem(k) {
      this.input.agency.splice(k, 1)
    },
    addMoreAgent() {
      this.input.agency.push({
        agencyname: '',
        couponquantity: null,
        couponpercentage: null,
        provincelist: [],
        startdate: '',
        enddate: ''
      })
    },
    async saveData() {
      if (await this.$validator.validate()) {
        if (this.edittype == 'create') {
          let projectId =
            this.input.projectid && this.input.projectid.id ? this.input.projectid.id : null
          this.input.projectid = projectId
          var data = {
            ...this.input,
            couponpercentage: parseFloat(this.input.couponpercentage),
            agency: this.input.agency.map(el => {
              return { ...el, agencyname: el.agencyname.name }
            })
          }
          var url = 'createdepacampaign'
        } else {
          var data = {
            campaignid: this.editdata.id,
            ...this.input,
            projectid: parseInt(this.input.projectid.id),
            couponpercentage: parseFloat(this.input.couponpercentage),
            agency: this.input.agency.map(el => {
              return {
                agencyname: el.agencyname.name,
                id: el.agencyid,
                couponquantity: el.couponquantity,
                provincelist: el.provincelist,
                startdate: el.startdate,
                enddate: el.enddate
              }
            }),
            status: this.editdata.status,
            deleteList: []
          }
          var url = 'updatedepacampaign'
        }
        this.saveloading = true
        var response = await api[url](data)
        this.saveloading = false
        if (response == 204) {
          this.$emit('onsave')
          if (this.edittype == 'create') {
            this.$swal.fire({
              type: 'success',
              title: '<div class="headline primary--text bold7 fs-24">บันทึกข้อมูลสำเร็จ</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
          } else {
            this.$swal.fire({
              type: 'success',
              title: '<div class="headline primary--text bold7 fs-24">แก้ไขข้อมูลสำเร็จ</div>',
              confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
            })
          }
        } else if (response == 300) {
          this.$swal.fire({
            title: 'Input negative numbers',
            type: 'error'
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-error {
  color: red;
}

.input-group {
  position: relative;
}

.input-group::after {
  content: '%';
  color: #bdbdbd;
  position: absolute;
  top: 17px;
  right: 17px;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/view/techhuntMaster/CampaignEdit.vue